import React from 'react';
import { NCZICluster } from '../../../../../Interfaces/ncziTypes';
import EHREntryItem from './EHREntryItem';
import NZCIListItem from '../../../../Base/NZCIListItem';
// @ts-ignore
import styles from './EHRCluster.module.scss';
import NZCIListCluster from '../../../../Base/NZCIListCluster';

interface Props {
	cluster: NCZICluster | undefined;
}

const EHRCluster: React.FC<Props> = props => {
	const { cluster } = props;

	if (!cluster) {
		return <></>;
	}

	return (
		<div className={styles.wrapper}>
			<NZCIListCluster title={cluster.name} />
			{cluster.items.map((entryItem, key) => (
				<EHREntryItem item={entryItem} key={key} />
			))}
		</div>
	);
};

export default EHRCluster;
